import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getMenuADStart,
  getMenuADSuccess,
  getMenuADFailed,
  getSubMenuADStart,
  getSubMenuADSuccess,
  getSubMenuADFailed,
} from "../redux/menu";

import {
  getAuthorizationDocumentMenuAPI,
  getAuthorizationDocumentSubMenuAPI,
} from "core/http/service/authorizationDocument";

import { SCREEN } from "helper/roleChecker/Screens";

function* getMenuItemAD() {
  try {
    const res = yield call(getAuthorizationDocumentMenuAPI, SCREEN.IP_014);
    yield put({
      type: getMenuADSuccess.type,
      payload: res.data,
    });
  } catch (error: any) {
    yield put({
      type: getMenuADFailed.type,
    });
  }
}

function* getSubMenuItemAD(action: ReturnType<typeof getSubMenuADStart>) {
  try {
    const res = yield call(getAuthorizationDocumentSubMenuAPI, {
      screenCode: SCREEN.IP_014,
      id: action.payload.id,
    });
    yield put({
      type: getSubMenuADSuccess.type,
      payload: {
        id: action.payload.id,
        data: res.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: getSubMenuADFailed.type,
      payload: {
        id: action.payload.id,
      },
    });
  }
}

function* watchGetMenuAD() {
  yield takeLatest(getMenuADStart.type, getMenuItemAD);
}

function* watchGetSubMenuAD() {
  yield takeLatest(getSubMenuADStart.type, getSubMenuItemAD);
}

export default function* getMenuADSaga() {
  yield all([watchGetMenuAD(), watchGetSubMenuAD()]);
}
